module.exports = __webpack_public_path__ + "img/tick.e660b79b.svg";